// Ingredients CTA for recipe experiences that use the Whisk or Myxx
// shopping-list integrations.
import { must } from "@/common/utils/must";
import { whiskTypes } from "@/modules/ExperienceData";
import LinkData, { linkTypes } from "@/plugin/LinkData";
import * as labelUtils from "@/plugin/labelUtils";
import { clusterNames, shopWindowNames } from "@/plugin/recipeShopWindows";
import type ExperienceData from "@/modules/ExperienceData";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";

function handleWhiskWidgetLink(experienceData: ExperienceData, link?: unknown) {
  const idexperience = experienceData.idexperience;
  const url = `http://play.pixmoto.com/recipe/${idexperience}`;
  const whisk = must(window.whisk, "window.whisk");
  whisk.queue.push(() => {
    whisk.shoppingList.addRecipeToList({
      recipeUrl: url,
    });
  });
}

export function registerWhiskData(
  shopWindowMap: Record<string, ShopWindowConfig>,
  experienceData: ExperienceData,
) {
  const integration = experienceData.getIntegration();
  const idexperience = experienceData.idexperience;
  let type: unknown = whiskTypes.LINK;

  if (
    integration &&
    integration.parameters &&
    integration.parameters.length > 0
  ) {
    type = integration.parameters[0];
  }

  if (type === whiskTypes.LINK) {
    const url =
      "https://list.whisk.com/?redirect=" +
      encodeURIComponent(
        "/add_recipe_to_list?url=" +
          encodeURIComponent(`http://play.pixmoto.com/recipe/${idexperience}`) +
          "&whisk_content=recipe&whisk_medium=display",
      );

    shopWindowMap[shopWindowNames.LIST].links = {
      cta: new LinkData(
        linkTypes.URL,
        url,
        "ingredients.cta",
        true,
        labelUtils.getClusterLabel(
          clusterNames.INGREDIENT,
          experienceData.style,
        ),
      ),
    };
  } else if (type === whiskTypes.MODAL) {
    shopWindowMap[shopWindowNames.LIST].links = {
      cta: new LinkData(
        linkTypes.FUNCTION,
        handleWhiskWidgetLink,
        "ingredients.cta",
        true,
        labelUtils.getClusterLabel(
          clusterNames.INGREDIENT,
          experienceData.style,
        ),
      ),
    };
  }
}

function handleMyxxWidgetLink(experienceData: ExperienceData, link?: unknown) {
  const idexperience = experienceData.idexperience;
  const url = `http://play.pixmoto.com/recipe/${idexperience}`;
  const myxx = must(window.myxx, "window.myxx");

  myxx.myxxBuildCartScaffolding(url, "walmart", "cart");
}

export function registerMyxxData(
  shopWindowMap: Record<string, ShopWindowConfig>,
  experienceData: ExperienceData,
) {
  shopWindowMap[shopWindowNames.LIST].links = {
    cta: new LinkData(
      linkTypes.FUNCTION,
      handleMyxxWidgetLink,
      "ingredients.cta",
      true,
      labelUtils.getClusterLabel(clusterNames.INGREDIENT, experienceData.style),
    ),
  };
}
